import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../assets/css/accountmetrics.scss";
import Arrow from "../../assets/images/arrowside.svg";
import Title from "./title";
import ProgressBar from "@ramonak/react-progress-bar";

const StatFormatter = (data) => {
  // const Stat = data ? data.toLowerCase() : '';

  const classList =
    String(data).toLowerCase() === "success"
      ? "StatusPassed"
      : String(data).toLowerCase() === "failed"
        ? "StatusFailed"
        : "StatusInProgress";

  return <div className={`AMStat ${classList}`}>{data}</div>;
};

const AMDropdown = (props) => {

  const [descOpen, setDescOpen] = useState(false);
  const [countdown, setCountdown] = useState("");
  const targetLoss = parseInt(props?.targetValue?.replace(/[$,]/g, ""), 10);
  const completed = parseInt(targetLoss - parseInt(props?.result));
  // console.log(props, "THESE ARE THE PROPS");
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const now = new Date().getTime();
  //     const distance = targetDate - now;
  //     if (distance <= 0) {
  //       clearInterval(interval);
  //     } else {
  //       const hours = Math.floor(
  //         (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  //       );
  //       const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //       const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  //       setCountdown(`${hours}: ${minutes}: ${seconds}`);
  //     }
  //   });
  // }, []);

  const calculateRemainingTime = () => {
    const currentGMTTime = new Date();
    const targetGMT2Time = new Date();

    targetGMT2Time.setUTCHours(21, 0, 0, 0);

    let remaining = targetGMT2Time - currentGMTTime;

    if (remaining <= 0) {
      const nextDayGMT2Time = new Date(targetGMT2Time);
      nextDayGMT2Time.setDate(nextDayGMT2Time.getDate() + 1);
      remaining = nextDayGMT2Time - currentGMTTime;
    }

    return remaining;

  };


  const [timeRemaining, setTimeRemaining] = useState(calculateRemainingTime());
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(timeRemaining - 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeRemaining]);

  const showRemaining = (endTime) => {
    const days = Math.floor(timeRemaining / (24 * 60 * 60 * 1000));
    const hours = Math.floor(
      (timeRemaining % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
    );
    const minutes = Math.floor(
      (timeRemaining % (60 * 60 * 1000)) / (60 * 1000)
    );
    const seconds = Math.floor((timeRemaining % (60 * 1000)) / 1000);

    return `${hours }:${minutes}:${seconds}`;
  };


  const handleDesc = (e) => {
    e.preventDefault();
    setDescOpen(!descOpen);
  };

  return (
    <div className="DropdownBox">
      <div
        className="d-flex align-items-center gapp-20 mbb-10 DropdownHead space-between"
        onClick={handleDesc}
      >
        <Title four>{props.head}</Title>
        <div className="DropdownStatus">
          {props.status ? StatFormatter(props.status) : false}
        </div>
        {/* <div>
          <img
            src={Arrow}
            className={"DropdownArrow " + (descOpen && "true")}
            alt=""
          />
        </div> */}
      </div>
      <div className={"mbb-10 DropdownDesc " + (descOpen && "true")}>
        <Title three>{props.desc}</Title>
      </div>

      <div style={{ display: "flex" }}>
        <Grid container justifyContent="space-between">
          <Grid>
            {props.desc === "Max Daily Loss" ? (props.remaining ?
              (props.desc === "Max Daily Loss" || (
                <div className="DropdownResult">
                  Remaining : {props.remaining}
                </div>
              )) : (<div className="DropdownResult">
                {props.result ? `Results : ${props.result}` : false}
              </div>)) : (<div className="DropdownResult">
                {props.result ? `Results : ${props.result}` : false}
              </div>)}
            {/* {props.desc === "Max Daily Loss" ? null : props.remaining ? (
              <div className="DropdownResult">
                Remaining : {props.remaining}
              </div>
            ) : (
              <div className="DropdownResult">
                {props.result ? `Results : ${props.result}` : false}
              </div>
            )} */}
          </Grid>
          <Grid></Grid>
        </Grid>
        {props.desc === "Max Daily Loss" ? (
          <div className="timer-container d-flex">
            <Typography className="timer-text" style={{ textWrap: "nowrap" }}>
              Timer Reset In : {showRemaining()}
            </Typography>
          </div>
        ) : (
          <></>
        )}
      </div>
      {props.desc === "Max Daily Loss" && (
        <Grid mt={2}>
          <ProgressBar
            height="12px"
            baseBgColor="#8F8F8F"
            bgColor="#FDE74C"
            labelColor="#181818"
            labelSize="10px"
            width={"100%"}
            customLabel={props.targetValue && props.remaining ?
              parseInt(props.targetValue.replace(/[$,]/g, ""), 10) -
              parseInt(props.remaining.replace(/[$,]/g, "")) : false
            }
            completed={
              parseInt(props.targetValue.replace(/[$,]/g, ""), 10) -
              parseInt(props.remaining ? props.remaining.replace(/[$,]/g, "") : false)
            }
            maxCompleted={parseInt(props.targetValue.replace(/[$,]/g, ""), 10)}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
            }}
          >
            <div className="DropdownResult">
              {" "}
              Remaining : ${props.remaining}
            </div>
            <div className="DropdownResult"> Max : {props.targetValue}</div>
          </div>
        </Grid>
      )}
      {/* <div className="DropdownBorder mbb-20">
        <svg
          width="364"
          height="1"
          viewBox="0 0 364 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            x1="0.5"
            y1="0.5"
            x2="363.5"
            y2="0.5"
            stroke="url(#paint0_linear_541_6513)"
            strokeLinecap="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear_541_6513"
              x1="378.21"
              y1="1"
              x2="0"
              y2="0.999971"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="white" stopOpacity="0" />
              <stop offset="1" stopColor="white" />
            </linearGradient>
          </defs>
        </svg>
      </div> */}
    </div>
  );
};

export default AMDropdown;
